import { render, staticRenderFns } from "./confirmUploadCollectionModal.vue?vue&type=template&id=139a7ab7&"
import script from "./confirmUploadCollectionModal.vue?vue&type=script&lang=js&"
export * from "./confirmUploadCollectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports